import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { environment } from 'src/environments/environment';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';

@Component({
  selector: 'app-store-profile',
  templateUrl: './store-profile.component.html',
  styleUrls: ['./store-profile.component.scss'],
})
export class StoreProfileComponent implements OnInit {
  public buyCharacterSelectedName = 'EQUIPMENT TYPE';
  public itemAboutToBuy: any = null;
  public imgUrl = environment.ImageUrl;
  public buyCharacterList: any = {};
  public modelRef: any = null;
  public availableItemToBuy: any = [];
  carouselOptions: any = {
    // grabCursor: true,
    // loop: true,
    // centeredSlides: true,
    slidesPerView: 3,
    // effect: "coverflow",
    // coverflowEffect: {
    //   rotate: 0,
    //   stretch: 50,
    //   depth: 100,
    //   modifier: 1,
    //   slideShadows: true,
    // }
    // effect: "cube",
    // cubeEffect: {
    //   shadow: true,
    //   slideShadows: true,
    //   shadowOffset: 20,
    //   shadowScale: 0.94,
    // },
  }
  swiper: any = {};
  swiperEvent(e) {
    this.swiper = e;
  }
  /**
   * Constructor
   */
  constructor(
    private toastr: ToastrService,
    private auth: AuthServiceService,
    private modalService: NgbModal,
    private sharedService: SharedService,
    public roleService: RoleService,
    private customerService: CustomerService
  ) { }

  ngOnInit(): void {
    this._getAvailableCharacterListForMember();
  }

  private _getAvailableCharacterListForMember() {
    console.log("AVATAR 1")
    this.customerService.getCharacterListForMember().subscribe((resp: ApiResponse) => {
      if (resp.body && resp.body.length > 0) {
        this._getAllProfileCharacter(resp.body);
      } else {
        this._getAllProfileCharacter([]);
      }
    });
  }

  private _getAllProfileCharacter(currentMemberItems: Array<any>): void {
    this.buyCharacterList = {};
    this.auth.getAllProfileCharacter().subscribe((response: ApiResponse) => {
      let availableItemToBuy =
        response.body.filter((i: any) => {
          let k = currentMemberItems.filter(
            (c) => c.profileCharacter.id == i.id
          );
          return k.length == 0;
        }) || [];
      let output = {};
      for (let i of availableItemToBuy) {
        if (
          i.roleName &&
          (this.roleService.roles?.level.includes(i.roleName) ||
            this.roleService.roles?.users.includes(i.roleName))
        ) {
          output[i.category]
            ? output[i.category].push(i)
            : (output[i.category] = [i]);
        } else {
          output[i.category]
            ? output[i.category].push(i)
            : (output[i.category] = [i]);
        }
      }
      this.buyCharacterList = output;
      this.availableItemToBuy = availableItemToBuy;
    });
  }

  public setCharName(name) {
    this.itemAboutToBuy = null;
    this.buyCharacterSelectedName = name;
  }

  public removeCharName() {
    this.buyCharacterSelectedName = 'Character Name';
  }

  public buyChar(model, itemToBuy: any) {
    this.modelRef ? this.modelRef.close() : '';
    this.itemAboutToBuy = itemToBuy;
    this.modelRef = this.modalService.open(model, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'avatar',
    });
  }

  public buyItem() {
    this.auth
      .buyCharacterForMember({ characterId: this.itemAboutToBuy.id })
      .subscribe(
        (resp: ApiResponse) => {
          this.toastr.success(resp.message);
          this.itemAboutToBuy = null;
          this.modelRef.close();
          this._getAvailableCharacterListForMember();
        },
        ({ error }) => {
          this.toastr.error(error.message);
        }
      );
  }

  GoToMyTabs(index: any = 1) {
    this.sharedService.triggerSelectMyTab(index);
  }
}
